import { RouteObject } from "react-router-dom";

export const auditingRoutes: RouteObject = {
  id: "auditing",
  path: "auditing",
  children: [
    {
      id: "auditingIndex",
      index: true,
      handle: {
        showSidebar: true,
      },
      lazy: async () => {
        const { AuditingPage } = await import("features/auditing/AuditingPage");
        return { Component: AuditingPage };
      },
    },
  ],
};
